module.exports = __webpack_public_path__ + "static/img/iphonex-modal.8ea9318b.png";